module.exports = __webpack_public_path__ + "static/media/loginBg.886446c8.jpg";